module.exports = __webpack_public_path__ + "static/media/drop-down-arrow.66b89c60.svg";